import "../css/MainCss.css";
import rms from "./img/rms.jpeg";
import { FaReact } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { TbBrandCss3 } from "react-icons/tb";
import { TiHtml5 } from "react-icons/ti";
import { TbBrandTypescript } from "react-icons/tb";

function Main() {
  return (
    <div className="paiMain">
      <div className="testText">
        <h1 className="t4">Estudos e conhecimento na área de :</h1>
      </div>
      <div className="rsEstudos">
        <div className="imagens">
          <img src={rms} className="imgrms" alt="" />
        </div>

        <ul className="itensL">
          <li className="contl"> Freelancer como Frontend Developer.</li>
          <li className="contl">
            Desenvolvimento de interfaces modernas e de alta qualidade.
          </li>
          <li className="contl">Animações, responsividade.</li>
          <li className="contl">Administrador de Redes.</li>
          <li className="contl">Manutenção de celulares e computadores.</li>
        </ul>
      </div>

      <div className="conhecimentos">
        <h2 className="t5">Linguagens de conhecimento:</h2>
        <br />
        <ul className="lgens">
          <li className="inc">
            <FaReact />
          </li>
          <li className="inc">
            <IoLogoJavascript />
          </li>
          <li className="inc">
            <TbBrandCss3 />
          </li>
          <li className="inc">
            <TiHtml5 />
          </li>
          <li className="inc">
            <TbBrandTypescript />
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Main;
